// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*image-cropper {\n  padding: 1px;\n}*/\nimage-cropper {\n  height: 100%;\n}", "",{"version":3,"sources":["webpack://./src/app/editor/cropper/cropper.component.scss"],"names":[],"mappings":"AAAA;;EAAA;AAIA;EACE,YAAA;AAAF","sourcesContent":["/*image-cropper {\n  padding: 1px;\n}*/\n\nimage-cropper {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
